export default __webpack_public_path__ + "static/media/balance.e8b2730a.png";